
import Btn from '~/components/Btn.vue';
import FormInput from '~/components/FormInput.vue';
import Page from '~/components/Page.vue';

export default {
    components: { Page, FormInput, Btn },
    head() {
        return {
            title: 'Подарочный сертификат - Теннисный магазин 7/6',
            meta: [
                { hid: 'description', name: 'description', content: 'Подарочные сертификаты SevenSix' },
                { hid: 'keywords', name: 'keywords', content: 'подарочный сертификат теннис' },
            ],
        };
    },
    data() {
        return {
            form: {
                f: '',
                i: '',
                o: '',
                phone: '',
                email: '',
                sum: '',
            },
            errors: null,
            error: null,
            process: false,
        };
    },
    mounted() {
        this.prefillFromProfile();
    },
    methods: {
        fieldError(field) {
            if (!this.errors || !this.errors[field]) {
                return null;
            }
            return this.errors[field][0];
        },
        prefillFromProfile() {
            if (this.$auth && this.$auth.loggedIn && this.$auth.user) {
                this.form.f = this.$auth.user.f || '';
                this.form.i = this.$auth.user.i || '';
                this.form.o = this.$auth.user.o || '';
                this.form.email = this.$auth.user.email || '';
                this.form.phone = this.$auth.user.phone || '';
            }
        },
        normalizeSum(value) {
            if (value === null || value === undefined) {
                return null;
            }
            const digits = String(value).replace(/[^0-9]/g, '');
            return digits ? parseInt(digits, 10) : null;
        },
        async submit() {

            console.log(1);
            this.process = true;
            this.errors = null;
            this.error = null;

            const payload = {
                f: this.form.f,
                i: this.form.i,
                o: this.form.o,
                phone: this.form.phone,
                email: this.form.email,
                sum: this.normalizeSum(this.form.sum),
            };

            try {
                const { data } = await this.$axios.post('api/v1/giftcard', payload);
                window.location.assign(data.url);
            } catch (e) {
                if (e.response && e.response.status === 422) {
                    if (e.response.data.errors) {
                        this.errors = e.response.data.errors;
                        this.error = 'Пожалуйста, корректно заполните форму';
                    } else {
                        this.error = e.response.data.message;
                    }
                } else {
                    this.error = 'Системная ошибка, попробуйте позже';
                }
                this.process = false;
            }
        },
    },
};
